import React, { Component } from "react";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { utils } from "../../../utils";

class MainLogo extends Component<{}, {}> {
    state = {};

    getStyleClases = () => {
        return "login-logo";
    };

    getSmallLogoClass = () => {
        if (utils.isI1SmartMarketing() || utils.isDepLiveChat() || utils.isInterChanges()) {
            return "";
        } else {
            return "interchanges";
        }
    };

    render() {
        return (
            <div className={this.getStyleClases()}>
                <img
                    className={`large-logo ${utils.isInterChanges() ? "interchanges" : ""}`}
                    src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO}
                    alt="logo"
                />
                <img
                    className={`small-logo ${this.getSmallLogoClass()}`}
                    src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_MOBILE_LOGO}
                    alt="logo"
                />
            </div>
        );
    }
}

export default MainLogo;